namespace Gordic.Epk.WebControls {

    interface IBeforePrepareConfigDelegate {
        signingReason: string
    }

    /**
     * Podepisovací objekt určený pro EPK
     * @authors pnovak, thazmuka
     * @since 480.1.0.781
    */
    export class GEpkSigner extends Gordic.Wfl.WebClient.GByteSigner {

        public finalizeConfigDelegate: <T extends IGCustomDto>(config: Gordic.Wfl.Interface.GWflSignCreateConfig, customDto?: T) => JQuery.Promise<Gordic.Wfl.Interface.GWflSignCreateConfig, IGReasonResponse>;

        private reasonDto: IBeforePrepareConfigDelegate;

        /** konstruktor */
        constructor(opt: { cnt?: any, povoleniPraceDialoguDuvoduPodpisu: boolean, ktgDto?: GKtgDpoSupportDbParamsDto, row?: Wfl.Interface.GPodpisovaKnihaDto }) {

            var ktgDto = opt.ktgDto;
            var row = opt.row;
            var dpoEnabled = (ktgDto == null || ktgDto.gin_sgn_ktgdp == null) ? false : ktgDto.gin_sgn_ktgdp == 0 ? false : true;

            if (dpoEnabled === false ||
                opt.povoleniPraceDialoguDuvoduPodpisu === false ||
                ktgDto == null ||
                row == null
                || row.ktg_priz_edit_text === 0) {    // pokud není aktivní editace, rovnou to přeskočím

                // např. hromadné vyřízení
                super(undefined, (custDto) => {
                    return this._chooseCertDelegate(custDto);
                });
            }
            else {
                // jednotlivé vyřízení
                super(() => {
                    return this._beforeCertDelegate(opt.cnt, opt.row!);
                }, (custDto) => {
                    return this._chooseCertDelegate(custDto);
                });
            }

            //dsebesta 16.08.2023 indikace zda jde o SK podpis 
            var K203Param = Gordic.Gin.WebClient.GK203Handler.GetK203ParamsImmediate();
            this._configParams.modifyFileInput = (K203Param != null && K203Param.gin_upsr_povol != null && K203Param.gin_upsr_povol == 1)
            
            
        }

        private getSrv(cnt) {
            return cnt && !(cnt instanceof Window) && cnt.createServiceContent ? cnt.createServiceContent({ className: "Gordic.Gin.WebClient.GKtgDpoSupport", params: {} })
                : new GContent({ className: "Gordic.Gin.WebClient.GKtgDpoSupport", params: {} });  //servisni sluzba/content
        }

        private _beforeCertDelegate(cnt, row: Wfl.Interface.GPodpisovaKnihaDto) {
            // Gordic.Gin.WebClient\Gin\Gin\DuvodyPodpisu\GKtgDpoSupport.js
            var dfd = $.Deferred();

            var srv = this.getSrv(cnt);

            srv.call("GetSignReasonReplaced", { IxsDpo: row.ixs_dpo })
                .then((retval) => {
                    return retval.DuvodPodpisuTxt;
                })
                .then((ktg_duvod_txt: string) => {
                    return new GEpkVyberDpo().showDlg(cnt, row, ktg_duvod_txt);
                })
                .done((retVal: { ktg_duvod_txt: string }) => {
                    this.reasonDto = { signingReason: retVal.ktg_duvod_txt };
                    dfd.resolve();
                })
                .fail(() => {
                    dfd.reject({ reason: "jres:32000796", handled: false, type: EReasonType.userCancelled }).promise(); //RC 32000796 : Vyřízení bylo přerušeno.
                })
            return dfd;
        }

        private _chooseCertDelegate(custDto) {
            return this.choiceCertOKClick(custDto as any);
        }

        public prepareSign<T extends IGCustomDto>(signingConfig, customDto?: T) {
            // thazmuka (20.10.2021)
            // doplnění důvodu podpisu
            if (this.reasonDto != null)
                $.extend(true, signingConfig, this.reasonDto);
            customDto = customDto || {} as T;
            customDto.isNotConfigFinite = !!this.finalizeConfigDelegate;
            return super.prepareSign(signingConfig, customDto).then((config) => {
                return this.finalizeConfigDelegate ? this.finalizeConfigDelegate(config, customDto) : config;
            });
        }

    }

    export class GEpkVyberDpo {

        public showDlg(cnt: GContentType<any>, row: Wfl.Interface.GPodpisovaKnihaDto, ktg_duvod_txt: string) {
            var dfd = $.Deferred();
            cnt.dialogs.simpleForm("jres:32000798", this.createForm(row, ktg_duvod_txt), null, { dialogClass: "duvodPodpisuDialog"}) //RC 32000798 : Výběr důvodu podpisu
                .on('close', (event, value: { ktg_duvod_txt: string }) => {
                    if (value == null)
                        dfd.reject();
                    else
                        dfd.resolve(value);
                })
            return dfd.promise();
        }

        private createForm(row: Wfl.Interface.GPodpisovaKnihaDto, ktg_duvod_txt: string) {
            var Form = new Gordic.Forms.Form({ name: "FormDuvodPodpisu" });
            Form
                .addSection()
            Form
                .addRow({ label: "jres:32000800" }) //RC 32000800 : Kategorie důvodu podpisu
                .addField("gstringbox", {
                    disabled: true,
                    name: "ktg_nazev",
                    initialValue: row.ktg_nazev,
                    validators: [new Gordic.Validators.Required()]
                });

            Form
                .addRow("jres:32000799") //RC 32000799 : Důvod podpisu
                .addField("gstringbox", {
                    disabled: row.ktg_priz_edit_text !== 1,
                    initialValue: ktg_duvod_txt,
                    validators: [
                        new Gordic.Validators.Required(),
                        new Gordic.Validators.Length({ min: 1, max: 254, message: "jres:32000271" })
                    ], //RC 32000271 : Pole nesmí být prázdné a může obsahovat max. 254 znaků.
                    name: "ktg_duvod_txt",
                    rows: 4
                });
            return Form;
        }

    }

  

}

